import { Field, FieldProps } from "@fluentui/react-components";
import { Field as FormikField, FieldProps as FormikFieldProps, FieldValidator } from "formik";
import { IFormItem, TFieldWrapperComponentProps } from "./WithFormFieldWrapper.types";

import React from "react";

function WithFieldWrapper<T>(Component: React.ComponentType<TFieldWrapperComponentProps<T>>) {
    return (
        props: IFormItem<
            Omit<T, "className"> & {
                name: string;
            } & Pick<FieldProps, "label" | "validationMessage" | "validationState" | "hint" | "required" | "className" | "orientation">
        >
    ) => {
        const { formikFieldProps, componentFieldProps } = props;

        const { name, validationMessage, validationState, hint, label, orientation, className, ...restProps } = componentFieldProps;

        const isCheckbox = Component.displayName === "M365PulseFormCheckboxBase";
        const isSwitch = Component.displayName === "M365PulseFormSwitchBase";
        const hasOwnLabel = isCheckbox || isSwitch;
        return (
            <Field
                validationMessage={formikFieldProps.meta.error ?? validationMessage}
                validationState={formikFieldProps.meta.error ? "error" : validationState}
                label={!hasOwnLabel ? label : undefined}
                required={componentFieldProps.required}
                hint={hint}
                orientation={orientation}
                className={className}
            >
                {
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    <Component name={name} formikFieldProps={formikFieldProps} label={hasOwnLabel ? label : undefined} {...(restProps as T)} />
                }
            </Field>
        );
    };
}

const WithFormItemWrapper =
    <T extends { name: string }>(Component: React.ComponentType<IFormItem<T>>): React.FC<T & { validate?: FieldValidator }> =>
    (props) => (
        <FormikField name={props.name} validate={props.validate}>
            {(fieldProps: FormikFieldProps) => <Component componentFieldProps={props} formikFieldProps={fieldProps} />}
        </FormikField>
    );

export function WithFormFieldWrapper<T>(Component: React.ComponentType<TFieldWrapperComponentProps<T>>) {
    return WithFormItemWrapper(WithFieldWrapper(Component));
}
